export const SET_USER_INFO = "profile/SET_USER_INFO"
export const SET_USER_LEVEL = "profile/SET_USER_LEVEL"
export const SET_USER_VERIFY_STATUS = "profile/SET_USER_VERIFY_STATUS"
